export default __webpack_public_path__ + "static/media/default.9176288b.png";